import { render, staticRenderFns } from "./discountShopee.vue?vue&type=template&id=660ca27b&scoped=true&"
import script from "./discountShopee.vue?vue&type=script&lang=js&"
export * from "./discountShopee.vue?vue&type=script&lang=js&"
import style0 from "./discountShopee.vue?vue&type=style&index=0&id=660ca27b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ca27b",
  null
  
)

export default component.exports